import React, { useState } from 'react'
import { Box, TextField } from '@mui/material'
import { textInputStyles } from '../../../styles/classes/MobilePreviewClasses'
import ElementContainer from '../ElementContainer'

import {
  inputTypeValueTransformer,
  numericOptions
} from '../../../utils/mobilePreview'
import { useTranslation } from 'react-i18next'

const TextDescription = ({
  title,
  placeholder,
  inputFieldType,
  helpfulHint,
  onChangeValue,
  answer,
  isMandatory,
  decimals,
  isPreviewMode,
  disabled,
  ...rest
}) => {
  const [localValue, setLocalValue] = useState(answer)
  const { classes } = textInputStyles()
  const altStyle = numericOptions.includes(inputFieldType)
  const { t } = useTranslation()
  let suffix = ''

  if (inputFieldType === 'dollar_value') suffix = '$'
  if (inputFieldType === 'percentage_value') suffix = '%'
  let placeholderLocal = ''

  if (
    ['numeric_only', 'dollar_value', 'percentage_value'].includes(
      inputFieldType
    )
  ) {
    placeholderLocal = t('mobile_preview.text_description.enter_value')
  } else {
    placeholderLocal = t('mobile_preview.text_description.enter_description')
  }

  if (placeholder && placeholder !== '') {
    placeholderLocal = placeholder
  }

  const validateDecimals = text => {
    if (decimals && text && text.includes('.')) {
      const numberOfDecimals = text.split('.')[1]?.length
      if (numberOfDecimals && numberOfDecimals >= decimals + 1) {
        // +1 for limit the new decimal
        return text.slice(0, -1)
      }
    }
    return text
  }

  const updateValue = event => {
    const value = event.target.value
    let transformedValue = inputTypeValueTransformer(inputFieldType, value)
    if (
      ['dollar_value', 'percentage_value', 'numeric_only'].includes(
        inputFieldType
      )
    ) {
      transformedValue = validateDecimals(transformedValue)
    }
    setLocalValue(transformedValue)
  }

  const addSuffix = () => {
    setLocalValue(prevValue => {
      if (prevValue) {
        let newVal = prevValue
        if (suffix === '$') newVal = `${suffix} ${prevValue}`
        else newVal = `${prevValue} ${suffix}`
        onChangeValue(newVal)
        return newVal
      }
    })
  }

  function separateSymbolFromNumber (inputString) {
    if (!inputString) {
      return { symbol: '', number: '' }
    }
    const symbol = inputString.match(/[^\d.]/g)?.join('')
    if (!symbol) return { symbol, number: inputString }
    const number = inputString.replace(symbol, '')
    return { symbol, number }
  }

  const handleFocus = () => {
    if (
      ['dollar_value', 'percentage_value', 'numeric_only'].includes(
        inputFieldType
      )
    ) {
      setLocalValue(prevText => separateSymbolFromNumber(prevText).number)
    }
  }

  return (
    <ElementContainer
      title={title}
      helpfulHint={helpfulHint}
      isMandatory={isMandatory}
    >
      <Box>
        <TextField
          disabled={disabled}
          size="small"
          disableUnderline
          onBlur={addSuffix}
          onFocus={handleFocus}
          {...rest}
          variant="filled"
          InputProps={{
            disableUnderline: true,
            inputProps: {
              style: {
                textAlign: altStyle ? 'center' : 'left',
                justifyContent: 'center',
                alignItems: 'center',
                marginLeft: '6px'
              }
            }
          }}
          className={
            altStyle ? classes.textFieldStylesAlt : classes.textFieldStyles
          }
          multiline
          rows={altStyle ? 1 : 2}
          fullWidth
          placeholder={placeholderLocal}
          onChange={updateValue}
          value={localValue}
        />
      </Box>
    </ElementContainer>
  )
}

export default TextDescription
